// Auto-generated from segment.json
export default {
  "uiType": "element",
  "name": "Segment",
  "description": "A menu displays grouped navigation actions",
  "tagName": "ui-menu",
  "exportName": "UISegment",
  "content": [],
  "types": [
    {
      "name": "placeholder",
      "attribute": "placeholder",
      "description": "used as a placeholder for content in a layout.",
      "usageLevel": 1
    }
  ],
  "variations": [],
  "events": [],
  "settings": []
};
